// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"84":"3d5cbd21","89":"65b6b576","653":"e889987e"}[chunkId] + ".js";
};